import React from 'react';
import ImageRepositorySearch from './ImageRepositorySearch';
import EditorString from '../EditorString/EditorString';
import { EditorStringModel } from '../../Types/EditorString';

interface ImageRepositoryInitialScreenProps {
  onSearch: (text: string) => void;
  isLoading: boolean;
  text?: EditorStringModel;
}

const ImageRepositoryInitialScreen = ({
  onSearch,
  text,
  isLoading,
}: ImageRepositoryInitialScreenProps) => {
  return (
    <div className="m-auto flex max-w-xl flex-col items-center justify-center gap-2 text-center">
      {text && <EditorString {...text} />}
      <ImageRepositorySearch onSearch={onSearch} isLoading={isLoading} />
    </div>
  );
};

export default ImageRepositoryInitialScreen;
